import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const ScrollLockGuardian = () => {
  const location = useLocation();

  // Clean up on every route change
  useEffect(() => {
    const cleanup = () => {
      document.body.style.overflow = "";
      document.body.style.pointerEvents = "";
      document.body.removeAttribute("data-scroll-locked");
    };

    const timer = setTimeout(cleanup, 350);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  // MutationObserver: watch for stale data-scroll-locked
  useEffect(() => {
    const observer = new MutationObserver(() => {
      if (!document.body.hasAttribute("data-scroll-locked")) return;

      const hasVisibleOverlay =
        document.querySelector("[data-state='open'][role='dialog']") ||
        document.querySelector("[vaul-drawer][data-state='open']") ||
        document.querySelector("[data-radix-portal] [data-state='open']");

      if (!hasVisibleOverlay) {
        setTimeout(() => {
          const stillHasOverlay =
            document.querySelector("[data-state='open'][role='dialog']") ||
            document.querySelector("[vaul-drawer][data-state='open']") ||
            document.querySelector("[data-radix-portal] [data-state='open']");

          if (!stillHasOverlay) {
            document.body.style.overflow = "";
            document.body.style.pointerEvents = "";
            document.body.removeAttribute("data-scroll-locked");
          }
        }, 500);
      }
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["data-scroll-locked"],
    });

    return () => observer.disconnect();
  }, []);

  return null;
};
